/**
 * Shared styled components used by both YatzyGame and MultiplayerGame.
 * Only components that are truly identical between both game modes belong here.
 */
import styled from 'styled-components';

export const PositionedDie = styled.div<{ $x: number; $y: number; $rolling: boolean }>`
  position: absolute;
  top: ${p => p.$y}px;
  left: ${p => p.$x}px;
  transform: translate(-50%, -50%) scale(${p => p.$rolling ? 1.07 : 1});
  transition: top .55s cubic-bezier(.25,.7,.3,1), left .55s cubic-bezier(.25,.7,.3,1), transform .35s ease;
  will-change: top, left, transform;
  pointer-events: auto;
`;

export const SidebarSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex: 1 1 0;
    max-width: 520px;
  }
  @media (min-width: 1024px) {
    max-width: 560px;
    position: sticky;
    top: 20px;
    align-self: flex-start;
  }
  @media (min-width: 1280px) {
    max-width: 600px;
  }
`;

export const FabContainer = styled.div`
  /* FAB-systemet — alltid synligt */
  display: block;
`;

export const SpeedDialWrapper = styled.div`
  position: fixed;
  bottom: calc(20px + env(safe-area-inset-bottom, 0));
  right: calc(20px + env(safe-area-inset-right, 0));
  z-index: 1100;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  will-change: transform;
  transform: translateZ(0);
`;

export const DialActions = styled.div<{ $open: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
  transition: all 0.25s cubic-bezier(0.4, 0.0, 0.2, 1);
  transform: translateY(${p => p.$open ? '0' : '10px'}) translateZ(0);
  opacity: ${p => p.$open ? 1 : 0};
  pointer-events: ${p => p.$open ? 'auto' : 'none'};
  will-change: transform, opacity;
`;

export const DialBtn = styled.button<{ $isAiActive?: boolean }>`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 600;
  background: ${p => p.$isAiActive
    ? 'linear-gradient(135deg, #667eea, #764ba2)'
    : 'var(--theme-card-background, #fff)'};
  color: ${p => p.$isAiActive ? '#fff' : 'var(--theme-text, #222)'};
  box-shadow: 0 4px 12px rgba(0, 0, 0, .3);
  border: 2px solid ${p => p.$isAiActive ? '#667eea' : 'var(--theme-primary, #4caf50)'};
  transition: transform 0.15s cubic-bezier(0.4, 0.0, 0.2, 1);
  will-change: transform;
  transform: translateZ(0);
  position: relative;

  &:hover {
    transform: translateZ(0) scale(1.05);
    box-shadow: 0 6px 16px rgba(0, 0, 0, .4);
  }

  &:active {
    transform: translateZ(0) scale(0.95);
  }

  &:focus {
    outline: 2px solid var(--theme-primary, #4caf50);
    outline-offset: 2px;
  }
`;
